const cookie = {
  setCookie: (name, value, domain, expire) => {
    // domain=.youbaolian.top;写入cookie到主域 子域名都可用    path=/表示本站全部路径都可使用
    let cookie = `${name}=${escape(value)}`
    if (expire) {
      let date = new Date()
      date.setSeconds(date.getSeconds() + expire)
      cookie = `${cookie};expires=${date.toGMTString()}`
    }
    if (domain) {
      cookie = `${cookie};domain=${domain};path=/`
    }
    document.cookie = `${cookie}`
  },
  getCookie: (name) => {
    if (document.cookie.length > 0) {
      let start = document.cookie.indexOf(name + '=')
      if (start !== -1) {
        start = start + name.length + 1
        let end = document.cookie.indexOf(';', start)
        if (end === -1) end = document.cookie.length
        return unescape(document.cookie.substring(start, end))
      }
    }
    return ''
  },
  // 清理同名 token cookie 的全部变体(host-only + domain),避免旧登录残留
  // 与新版同名 cookie 并存导致 getCookie 取到旧的、登录后请求带错 token
  clearTokenCookie: (domain) => {
    const expired = 'expires=Thu, 01 Jan 1970 00:00:00 GMT'
    // host-only 变体:覆盖 path=/ 与当前目录路径
    document.cookie = `InsBackUserToken_V3=;${expired};path=/`
    document.cookie = `InsBackUserToken_V3=;${expired}`
    // domain 变体(与 setCookie 写入的 domain 一致)
    if (domain) {
      document.cookie = `InsBackUserToken_V3=;${expired};domain=${domain};path=/`
    }
  }
}
export default cookie



// WEBPACK FOOTER //
// ./src/utils/cookie.js